import React, { useState } from "react";
import Auth from "../../utils/AuthUtils";

function SEOFields({ seoData, setSeoData, slug = "", errors }) {
  const [input, setInput] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const value = input.trim();
      if (!value) return;

      if (seoData.tags.includes(value)) {
        setInput("");
        return;
      }

      setSeoData((prev) => ({
        ...prev,
        tags: [...prev.tags, value],
      }));

      setInput("");
    }
  };

  const removeTag = (index) => {
    setSeoData((prev) => ({
      ...prev,
      tags: prev.tags.filter((_, i) => i !== index),
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSeoData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <h5 className="mb-2">
        <i className="ti ti-globe text-primary me-1" />
        Search Engine Optimization Details
      </h5>

      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <div className="mb-3">
            <label className="form-label">Meta Title</label>
            <input
              type="text"
              name="metaTitle"
              className="form-control"
              placeholder="Meta Title"
              value={seoData.metaTitle}
              onChange={handleChange}
            />
            {errors.metaTitle && (
              <span className="errors text-danger">{errors.metaTitle}</span>
            )}
          </div>
        </div>

        <div className="col-lg-6 col-sm-12">
          <div className="mb-3">
            <label className="form-label">Meta Description</label>
            <input
              type="text"
              name="metaDescription"
              className="form-control"
              placeholder="Meta Description"
              value={seoData.metaDescription}
              onChange={handleChange}
            />
            {errors.metaDescription && (
              <span className="errors text-danger">
                {errors.metaDescription}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mb-3">
          <label className="form-label">Meta Keywords</label>
          <div
            style={{
              border: "1px solid #ccc",
              padding: "6px",
              borderRadius: "5px",
              minHeight: "40px",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {seoData.tags.map((tag, index) => (
              <span
                key={index}
                style={{
                  margin: "4px",
                  padding: "4px 8px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  borderRadius: "20px",
                }}
              >
                {tag}
                <span
                  onClick={() => removeTag(index)}
                  style={{ marginLeft: "8px", cursor: "pointer" }}
                >
                  ×
                </span>
              </span>
            ))}

            <input
              style={{ border: "none", flex: 1, minWidth: "120px" }}
              type="text"
              value={input}
              placeholder="Enter tags..."
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
          {errors.keywords && (
            <span className="errors text-danger">{errors.keywords}</span>
          )}

          <small className="text-muted d-block mt-1">
            <b>Note:</b> Press <b>Enter</b> or type a <b>comma (,)</b> to add
            multiple keywords.
          </small>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mb-3">
          <label className="form-label">Search Engine Preview</label>
          <div
            style={{
              border: "1px solid #ccc",
              padding: "12px",
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
            }}
          >
            <h5 style={{ color: "#1a0dab", fontSize: "18px" }}>
              {seoData.metaTitle || "Example Page Title"}
            </h5>
            <div style={{ color: "#006621", fontSize: "14px" }}>
              {Auth.getUserDetails("websiteUrl") || "https://www.example.com"}/
              {slug}
            </div>
            <div style={{ color: "#545454", fontSize: "13px" }}>
              {seoData.metaDescription ||
                "This is a short meta description that appears in Google search results..."}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SEOFields;
